/**
 * Converts a string in UPPER_SNAKE_CASE to sentence case.
 * Example: "EXAMPLE_STRING" → "Example string"
 */
export function upperSnakeCaseToSentenceCase(value: string): string {
  const words = value.toLowerCase().split('_');
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
  return words.join(' ');
}
